import api from '../utils/api';

export const getMenus = () => {
    return api.get('/config/menu', {});
};
